import React, { createContext, useState, useEffect } from "react";
import problemServices from "app/services/problem-service";
import useJumboAuth from "@jumbo/hooks/useJumboAuth";

export const MetadataContext = createContext({
  metadata: null,
  isLoading: false,
  error: null,
});

export const MetadataProvider = ({ children }) => {
  const { authToken } = useJumboAuth();
  const [metadata, setMetadata] = useState(null);
  const [isLoading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchMetadata = async () => {
      try {
        setLoading(true);
        const response = await problemServices.getProblemMetadata();
        setMetadata(response);
        setError(null);
      } catch (err) {
        console.error("Failed to fetch metadata:", err);
        setError(err.message || "Failed to fetch metadata");
      } finally {
        setLoading(false);
      }
    };
    fetchMetadata();
  }, [authToken]);

  return (
    <MetadataContext.Provider value={{ metadata, isLoading, error }}>
      {children}
    </MetadataContext.Provider>
  );
};
